const mapNewsletterItems = (id, newsletterData, items, func, components = []) => {
    if(!newsletterData || !newsletterData[id]) {
        return null
    }

    const itemIds = newsletterData[id]

    itemIds.forEach((itemId, index) => {
        const itemData = items[itemId]

        if(!itemData) {
            return null
        }

        func(components, itemData, index)
    })

    return components
}

export default mapNewsletterItems